// WebApi is deployed PER VENUE. The wizard already asks for a location, so we
// resolve the per-venue base from that selection rather than a single env var.
// Local dev: all venues share http://localhost:5002/ (the DEV_FALLBACK).
// Production per-venue hosts are set in .env.production (p-api/t-api/kc-api/ph-api).
// Keep those vars in sync there — an unset var silently falls back to localhost,
// which breaks prod booking and trips the browser's private-network-access prompt.
const DEV_FALLBACK = 'http://localhost:5002/';

function withTrailingSlash(url: string): string {
  return url.endsWith('/') ? url : url + '/';
}

export const LOCATION_API_BASE: Record<string, string> = {
  pasadena: withTrailingSlash(process.env.REACT_APP_RACE_API_BASE_URL_PASADENA ?? DEV_FALLBACK),
  tustin: withTrailingSlash(process.env.REACT_APP_RACE_API_BASE_URL_TUSTIN ?? DEV_FALLBACK),
  kansascity: withTrailingSlash(process.env.REACT_APP_RACE_API_BASE_URL_KANSASCITY ?? DEV_FALLBACK),
  phoenix: withTrailingSlash(process.env.REACT_APP_RACE_API_BASE_URL_PHOENIX ?? DEV_FALLBACK),
};

export function normalizeLocationKey(displayOrKey: string): string {
  return displayOrKey.toLowerCase().replace(/\s+/g, '');
}

export function resolveRaceApiBaseUrl(locationKey: string): string {
  const key = normalizeLocationKey(locationKey);
  const base = LOCATION_API_BASE[key];
  if (!base) {
    throw new Error(`Unknown location '${locationKey}' — no Race API base URL configured`);
  }
  return withTrailingSlash(base);
}
